import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { PublicService } from '../../../shared/services/public/public.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  standalone: true,
  styleUrl: './banner.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    DropdownModule,
    RadioButtonModule,
    ButtonModule,
    ReactiveFormsModule
  ],
  encapsulation: ViewEncapsulation.None,
})
export class BannerComponent {
  selectedOption: string | undefined; // Radio button value
  isSubmitting: boolean = false;
  registrationForm: FormGroup;
  formattedaddress: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private publicService: PublicService,
    private authService: AuthService,
    private router: Router,
  ) {
    // Initialize the form with fields and validation rules
    this.registrationForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      new_email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      addressStatus: ['', Validators.required],
    });
  }

  public AddressChange(address: any) { 
    //setting address from API to local variable 
     this.formattedaddress=address.formatted_address 
  } 
  
  async submitForm() {
    if (this.registrationForm.valid) {
      this.isSubmitting = true;
      const { email, password, ...userData } = this.registrationForm.value;
      const formData = {
        ...this.registrationForm.value,
        submittedAt: new Date().toISOString(),
      };
      try {
        const user = await this.authService.register(email, password);
        if (user) {
          await this.publicService.saveContactInfo();
          this.toastr.success('Message sent successfully!', 'Success');
          this.registrationForm.reset();
          this.registrationForm.markAsPristine();
          this.registrationForm.markAsUntouched();
          this.router.navigate(['/dashboard']);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isSubmitting = false;
      }
    } else {
      this.toastr.error('Please fill all required fields correctly.', 'Error');
    }
  }


  private handleError(error: any) {
    // Handle specific error codes
    if (error.code === 'auth/email-already-in-use') {
      this.toastr.error('This email is already in use.', 'Error');
    } else if (error.code === 'auth/weak-password') {
      this.toastr.error('Password is too weak. Please use a stronger password.', 'Error');
    } else if (error.message) {
      this.toastr.error(error.message, 'Error');
    } else {
      this.toastr.error('An unknown error occurred. Please try again.', 'Error');
    }
  }
}
